import PropTypes from 'prop-types';

var propTypes = {
    tagList: PropTypes.arrayOf(PropTypes.string).isRequired,
    onTagAdd: PropTypes.func.isRequired,
    onTagRemove: PropTypes.func,
    onClear: PropTypes.func,
    useBadges: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string,
    testId: PropTypes.string,
    'data-testid': PropTypes.string,
    badgeTestId: PropTypes.string,
    isValid: PropTypes.bool,
    primaryCondition: PropTypes.string,
    secondaryCondition: PropTypes.string,
    className: PropTypes.string,
    clearable: PropTypes.bool,
    withTooltips: PropTypes.bool,
    portalTarget: PropTypes.oneOfType([
        PropTypes.instanceOf(Element),
        PropTypes.node,
    ]),
    tooltipClassName: PropTypes.string,
};
var defaultProps = {
    label: '',
    tagList: [],
    useBadges: false,
    name: 'input',
    isValid: true,
    primaryCondition: '',
    secondaryCondition: '',
    className: '',
    clearable: true,
    withTooltips: false,
    tooltipClassName: '',
};

export { defaultProps, propTypes };
